"use client";

import "./newsroom-card.scss";
import { useState } from "react";

type Props = {
	readonly img: string;
	readonly type: string;
	readonly date: string;
	readonly title: string;
	readonly description: string;
	readonly onClickEvent: Function;
};

export default function NewsroomCard({
	img,
	type,
	date,
	title,
	description,
	onClickEvent,
}: Props) {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div
			className="newsroom-card border p-0"
			onClick={(e) => {
				onClickEvent();
			}}
		>
			<img src={img} alt={title} />
			<div className="p-4">
				<div className="press-release-container hmc-body-xs text-contentSubtle">
					<p className="hmc-body-xs hmc-overline inline-block uppercase ">
						{type}
					</p>
					<span className="line mx-3 inline-block bg-contentSubtle" />
					<p className="hmc-body-xs inline-block">{date}</p>
				</div>
				<div className="hmc-subtitle-m py-1.5 text-systemInfo">{title}</div>
				<div className="hmc-body-s text-systemInfo ">{description}</div>
			</div>
		</div>
	);
}
